import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { darken } from 'polished'
import styled from 'styled-components'
import Logo from '../../assets/svg/logo.svg'
import LogoM from '../../assets/svg/logoM.svg'
import Menu from '../Menu'
import Row, { RowFixed, RowBetween } from '../Row'
import { useActiveNetworkVersion } from 'state/application/hooks'
import { networkPrefix } from 'utils/networkPrefix'
import { isMobile } from 'react-device-detect'
import { AutoColumn } from 'components/Column'

const HeaderFrame = styled.div`
  display: grid;
  grid-template-columns: 1fr 120px;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  top: 0;
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.16);
  background: #011822;
  padding: 18px 30px 18px 22px;
  z-index: 2;

  @media (max-width: 1080px) {
    padding: 0.5rem 1rem;
    width: calc(100%);
    position: relative;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr 40px;
  }

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    padding: 0.5rem 1rem;
  `}
`

const HeaderControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: flex-end;

  @media (max-width: 1080px) {
    display: none;
  }
`

const HeaderRow = styled(RowFixed)`
  @media (max-width: 1080px) {
    width: 100%;
  }
`

const HeaderLinks = styled(Row)`
  justify-content: center;
  @media (max-width: 1080px) {
    padding: 0.5rem;
    justify-content: flex-end;
  }
`

const Title = styled(NavLink)`
  display: flex;
  align-items: center;
  pointer-events: auto;
  justify-self: flex-start;
  margin-right: 12px;
  :hover {
    cursor: pointer;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-self: center;
  `};
  @media (max-width: 1080px) {
    margin-right: 6px;
  }
  @media (max-width: 768px) {
    margin-right: 0;
  }
`

const UniIcon = styled.div`
  transition: transform 0.3s ease;
  :hover {
    transform: rotate(-5deg);
  }
`

const StyledNavLink = styled(NavLink)<{ $isActive: boolean }>`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: left;
  border-radius: 18px;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  font-size: 16px;
  width: fit-content;
  margin: 0 12px;
  padding: 8px 16px;
  font-weight: 400;

  border-radius: ${({ $isActive }) => ($isActive ? '18px' : 'unset')};
  background-color: ${({ theme, $isActive }) => ($isActive ? theme.activeNavBg : 'unset')};
  color: ${({ theme, $isActive }) => ($isActive ? theme.text2 : theme.text3)};

  :hover,
  :focus {
    color: ${({ theme }) => darken(0.1, theme.text2)};
  }

  @media (max-width: 1080px) {
    padding: 8px 12px;
    margin: 0 8px;
  }

  @media (max-width: 768px) {
    padding: 8px 10px;
    margin: 0 6px;
  }
`

export const StyledMenuButton = styled.button`
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  height: 35px;
  background-color: ${({ theme }) => theme.bg3};
  margin-left: 8px;
  padding: 0.15rem 0.5rem;
  border-radius: 0.5rem;

  :hover,
  :focus {
    cursor: pointer;
    outline: none;
    background-color: ${({ theme }) => theme.bg4};
  }

  svg {
    margin-top: 2px;
  }

  > * {
    stroke: ${({ theme }) => theme.text1};
  }
`

const SmallContentGrouping = styled.div`
  width: 100%;
  display: none;
  @media (max-width: 1080px) {
    display: initial;
  }
`

export default function Header() {
  const [activeNewtork] = useActiveNetworkVersion()

  const { pathname } = useLocation()

  return (
    <HeaderFrame>
      <HeaderRow>
        <Title to={networkPrefix(activeNewtork)}>
          <UniIcon>
            <img src={isMobile ? LogoM : Logo} alt="logo" />
          </UniIcon>
        </Title>
        <HeaderLinks>
          <StyledNavLink id={`pool-nav-link`} to={networkPrefix(activeNewtork)} $isActive={pathname === '/'}>
            Overview
          </StyledNavLink>
          <StyledNavLink
            id={`stake-nav-link`}
            to={networkPrefix(activeNewtork) + 'pools'}
            $isActive={pathname.includes('pools')}
          >
            Pools
          </StyledNavLink>
          <StyledNavLink
            id={`stake-nav-link`}
            to={networkPrefix(activeNewtork) + 'tokens'}
            $isActive={pathname.includes('tokens')}
          >
            Tokens
          </StyledNavLink>
        </HeaderLinks>
      </HeaderRow>
      <HeaderControls>
        {/* <NetworkDropdown /> */}
        {/* <SearchSmall /> */}
        <Menu />
      </HeaderControls>
      <SmallContentGrouping>
        <AutoColumn $gap="sm">
          <RowBetween>
            {/* <NetworkDropdown /> */}
            <Menu />
          </RowBetween>
          {/* <SearchSmall /> */}
        </AutoColumn>
      </SmallContentGrouping>
    </HeaderFrame>
  )
}
